/* ==========================================================================
   SP TOOLS USA — THEME GLOBAL JS
   Loaded on every SP-branded template. Module bodies are populated when
   each corresponding section/snippet ships. Preserve prototype IDs/classes.
   Source: itgeeksdesigner-…/script.js (relevant slices).
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

    /* ======================================================================
       1. ANNOUNCEMENT BAR — auto-rotate slides
       Reads .announcement-bar's data-rotate-ms attribute (set from
       section.settings.rotate_interval_ms). Respects prefers-reduced-motion.
       Source: index.html:25–43, script.js:7–19.
       ====================================================================== */
    var announcementBar = document.querySelector('.announcement-bar');
    var announcementSlides = announcementBar
        ? announcementBar.querySelectorAll('.announcement-slide')
        : [];
    if (announcementSlides.length > 0) {
        if (!announcementSlides[0].classList.contains('active')) {
            announcementSlides[0].classList.add('active');
        }
        if (announcementSlides.length > 1) {
            var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (!reduceMotion) {
                var intervalMs = parseInt(announcementBar.getAttribute('data-rotate-ms'), 10) || 4000;
                var announcementIndex = 0;
                setInterval(function () {
                    announcementSlides[announcementIndex].classList.remove('active');
                    announcementIndex = (announcementIndex + 1) % announcementSlides.length;
                    announcementSlides[announcementIndex].classList.add('active');
                }, intervalMs);
            }
        }
    }

    /* ======================================================================
       2. HERO SLIDER — fade autoplay (slideshow section)
       Wires the prototype's #heroSlider rotator to the Shopify hero section.
       Reads .section-hero[data-rotate-ms] (set from section.settings.change_slides_speed)
       and data-autoplay. Respects prefers-reduced-motion. Scope-guarded so the
       module is a no-op on non-home templates.
       Source: index.html:240–326, script.js:60–119.
       ====================================================================== */
    var heroRoot = document.querySelector('.section-hero');
    var heroSlider = document.getElementById('heroSlider');
    if (heroRoot && heroSlider) {
        var heroSlides = heroSlider.querySelectorAll('.hero-slide');
        var heroDots = heroRoot.querySelectorAll('.hero-dot');
        var heroPrev = document.getElementById('heroPrev');
        var heroNext = document.getElementById('heroNext');
        var heroCurrent = 0;
        var heroInterval;
        var heroAutoplay = heroRoot.getAttribute('data-autoplay') === 'true';
        var heroIntervalMs = parseInt(heroRoot.getAttribute('data-rotate-ms'), 10) || 6000;
        var heroReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function heroGoTo(index) {
            heroSlides.forEach(function (slide) { slide.classList.remove('hero-slide-active'); });
            heroDots.forEach(function (dot) { dot.classList.remove('hero-dot-active'); });
            heroSlides[index].classList.add('hero-slide-active');
            if (heroDots[index]) heroDots[index].classList.add('hero-dot-active');
            heroCurrent = index;
        }

        function heroNextSlide() { heroGoTo((heroCurrent + 1) % heroSlides.length); }
        function heroPrevSlide() { heroGoTo((heroCurrent - 1 + heroSlides.length) % heroSlides.length); }

        function heroStartAutoplay() {
            if (heroAutoplay && !heroReduceMotion && heroSlides.length > 1) {
                heroInterval = setInterval(heroNextSlide, heroIntervalMs);
            }
        }
        function heroStopAutoplay() { clearInterval(heroInterval); }

        if (heroSlides.length > 1) {
            heroDots.forEach(function (dot) {
                dot.addEventListener('click', function () {
                    var index = parseInt(dot.getAttribute('data-slide'), 10);
                    heroGoTo(index);
                    heroStopAutoplay();
                    heroStartAutoplay();
                });
            });
            if (heroPrev) {
                heroPrev.addEventListener('click', function () {
                    heroPrevSlide();
                    heroStopAutoplay();
                    heroStartAutoplay();
                });
            }
            if (heroNext) {
                heroNext.addEventListener('click', function () {
                    heroNextSlide();
                    heroStopAutoplay();
                    heroStartAutoplay();
                });
            }
            heroStartAutoplay();
        }

        // Customizer hook: theme-editor.js dispatches these on shopify:block:select / deselect
        // for SP hero slides so clicking a slide in the editor swaps the visible slide.
        heroSlider.addEventListener('sp:hero:goto', function (e) {
            var index = e && e.detail ? e.detail.index : 0;
            if (typeof index === 'number' && index >= 0 && index < heroSlides.length) {
                heroGoTo(index);
                heroStopAutoplay();
            }
        });
        heroSlider.addEventListener('sp:hero:resume', function () {
            heroStartAutoplay();
        });
    }

    /* ======================================================================
       3. PRODUCT SLIDER — generalized horizontal slider
       Wires every .section-products[data-slider-id] to its own track + arrows
       (#{id}Track / #{id}Prev / #{id}Next). Supports manual prev/next and
       optional autoplay (data-autoplay + data-autoplay-ms). Resets on resize.
       Source: index.html:448–635, script.js:121–175.
       ====================================================================== */
    document.querySelectorAll('.section-products[data-slider-id]').forEach(function (section) {
        var sliderId = section.getAttribute('data-slider-id');
        var track = section.querySelector('.products-track');
        var prev = section.querySelector('#' + sliderId + 'Prev');
        var next = section.querySelector('#' + sliderId + 'Next');
        if (!track) return;

        var offset = 0;
        var autoplayInterval;
        var autoplay = section.getAttribute('data-autoplay') === 'true';
        var autoplayMs = parseInt(section.getAttribute('data-autoplay-ms'), 10) || 5000;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function getStep() {
            var card = track.querySelector('.product-card');
            if (!card) return 0;
            var gap = parseInt(window.getComputedStyle(track).gap, 10) || 24;
            return card.offsetWidth + gap;
        }

        function getMaxOffset() {
            var trackWidth = track.scrollWidth;
            var viewportWidth = track.parentElement.offsetWidth;
            return Math.max(0, trackWidth - viewportWidth);
        }

        function move(direction) {
            var step = getStep();
            var max = getMaxOffset();
            if (max <= 0) return;
            if (direction > 0) {
                offset = offset >= max - 1 ? 0 : Math.min(offset + step, max);
            } else {
                offset = offset <= 0 ? max : Math.max(offset - step, 0);
            }
            track.style.transform = 'translateX(-' + offset + 'px)';
        }

        function startAutoplay() {
            if (autoplay && !reduceMotion) {
                autoplayInterval = setInterval(function () { move(1); }, autoplayMs);
            }
        }
        function stopAutoplay() { clearInterval(autoplayInterval); }

        if (prev) prev.addEventListener('click', function () { move(-1); stopAutoplay(); startAutoplay(); });
        if (next) next.addEventListener('click', function () { move(1); stopAutoplay(); startAutoplay(); });

        window.addEventListener('resize', function () {
            offset = 0;
            track.style.transform = 'translateX(0)';
        });

        startAutoplay();
    });

    /* ======================================================================
       4. MOBILE MENU — open / close
       Ports prototype script.js §2 (lines 22-43) verbatim with element-exists
       guards. Locks body scroll while open. Overlay click + ESC also close.
       ====================================================================== */
    var mobileMenuToggle = document.getElementById('mobileMenuToggle');
    var mobileMenuClose = document.getElementById('mobileMenuClose');
    var mobileMenu = document.getElementById('mobileMenu');
    var mobileMenuOverlay = document.getElementById('mobileMenuOverlay');

    function openMobileMenu() {
        if (!mobileMenu) return;
        mobileMenu.classList.add('active');
        if (mobileMenuOverlay) mobileMenuOverlay.classList.add('active');
        mobileMenu.setAttribute('aria-hidden', 'false');
        if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
        if (!mobileMenu) return;
        mobileMenu.classList.remove('active');
        if (mobileMenuOverlay) mobileMenuOverlay.classList.remove('active');
        mobileMenu.setAttribute('aria-hidden', 'true');
        if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }

    if (mobileMenuToggle) mobileMenuToggle.addEventListener('click', openMobileMenu);
    if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
    if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', closeMobileMenu);
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('active')) {
            closeMobileMenu();
        }
    });

    /* ======================================================================
       5. MAIN NAV — pin to top on scroll (+ shadow)
       Sticky-via-CSS doesn't work because the section group wraps header + nav
       in one div, leaving no room for `position: sticky` to range over. So when
       the user opts into sticky (via .main-nav--sticky), we toggle .is-pinned
       (position: fixed) once the nav's natural top reaches the viewport, and
       insert a same-height spacer to keep page layout from jumping. The
       .scrolled class is preserved for the existing box-shadow rule.
       Throttled via requestAnimationFrame to keep INP <200ms.
       ====================================================================== */
    var mainNav = document.getElementById('mainNav');
    if (mainNav) {
        var stickyEnabled = mainNav.classList.contains('main-nav--sticky');
        var navSpacer = null;
        if (stickyEnabled) {
            navSpacer = document.createElement('div');
            navSpacer.className = 'main-nav-spacer';
            navSpacer.setAttribute('aria-hidden', 'true');
            navSpacer.style.display = 'none';
            mainNav.parentNode.insertBefore(navSpacer, mainNav.nextSibling);
        }

        var navNaturalTop = 0;
        var measureNav = function () {
            if (!stickyEnabled) return;
            mainNav.classList.remove('is-pinned');
            if (navSpacer) navSpacer.style.display = 'none';
            navNaturalTop = mainNav.getBoundingClientRect().top + window.scrollY;
        };
        measureNav();
        window.addEventListener('resize', measureNav, { passive: true });

        var navScrollTicking = false;
        window.addEventListener('scroll', function () {
            if (navScrollTicking) return;
            navScrollTicking = true;
            window.requestAnimationFrame(function () {
                var sy = window.scrollY;
                if (sy > 20) {
                    mainNav.classList.add('scrolled');
                } else {
                    mainNav.classList.remove('scrolled');
                }
                if (stickyEnabled) {
                    if (sy >= navNaturalTop) {
                        if (!mainNav.classList.contains('is-pinned')) {
                            if (navSpacer) {
                                navSpacer.style.height = mainNav.offsetHeight + 'px';
                                navSpacer.style.display = 'block';
                            }
                            mainNav.classList.add('is-pinned');
                        }
                    } else if (mainNav.classList.contains('is-pinned')) {
                        mainNav.classList.remove('is-pinned');
                        if (navSpacer) navSpacer.style.display = 'none';
                    }
                }
                navScrollTicking = false;
            });
        }, { passive: true });
    }

    /* ======================================================================
       6. BACK TO TOP
       Wired up when back-to-top renders. Prototype: script.js §6.
       ====================================================================== */
    var backToTopBtn = document.getElementById('backToTop');
    if (backToTopBtn) {
        var backToTopThreshold = parseInt(backToTopBtn.dataset.threshold, 10) || 400;
        var backToTopTicking = false;
        window.addEventListener('scroll', function () {
            if (backToTopTicking) return;
            backToTopTicking = true;
            window.requestAnimationFrame(function () {
                if (window.scrollY > backToTopThreshold) {
                    backToTopBtn.classList.add('visible');
                } else {
                    backToTopBtn.classList.remove('visible');
                }
                backToTopTicking = false;
            });
        }, { passive: true });

        backToTopBtn.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    /* ======================================================================
       7. NEWSLETTER FORM
       Replaces prototype's setTimeout demo with Shopify {% form 'customer' %}
       success/error rendering via form.posted_successfully?.
       Wired up when newsletter.liquid ships. Prototype: script.js §7.
       ====================================================================== */
    // TODO(newsletter): handle inline success message render on form.posted_successfully?.

    /* ======================================================================
       8. CART DRAWER — Quick-add → Dawn <cart-drawer> pattern.
       The drawer markup (snippets/cart-drawer.liquid) is the unified
       Dawn-mechanism + SP-design drawer. Cart adds POST to /cart/add.js
       with sections so Dawn's drawer.renderContents() can re-paint the
       drawer body + cart-icon-bubble in one round-trip. Line item qty +/-
       and remove are handled by Dawn's <quantity-input> / <cart-remove-button>
       web components — no JS needed here for those.
       ====================================================================== */
    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.product-quick-add[data-variant-id]');
        if (!trigger) return;
        e.preventDefault();
        var variantId = trigger.getAttribute('data-variant-id');
        if (!variantId || trigger.disabled) return;
        var originalHTML = trigger.innerHTML;
        trigger.disabled = true;
        trigger.classList.add('is-loading');

        var drawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: variantId, quantity: 1 }] };
        if (drawer && typeof drawer.renderContents === 'function') {
            body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(body)
        })
            .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
            .then(function (res) {
                if (!res.ok) throw new Error(res.data && res.data.description ? res.data.description : 'Add to cart failed');
                if (drawer && typeof drawer.renderContents === 'function') {
                    drawer.renderContents(res.data);
                } else {
                    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
                }
                trigger.innerHTML = '<i class="ph-bold ph-check" aria-hidden="true"></i> Added';
            })
            .catch(function (err) {
                trigger.innerHTML = '<i class="ph-bold ph-x" aria-hidden="true"></i> Try again';
                // Surface Shopify's actual reason ("All N in stock are in your cart", etc.)
                // on the card that was clicked — quick-add doesn't go through Dawn's
                // <product-form>, so the cartError pub/sub event never fires for it.
                spShowCardError(trigger, err && err.message ? err.message : 'Add to cart failed');
                // Shopify may still partially fulfill on error; resync cart UI.
                spRefreshCartSections();
            })
            .then(function () {
                setTimeout(function () {
                    trigger.innerHTML = originalHTML;
                    trigger.disabled = false;
                    trigger.classList.remove('is-loading');
                }, 1500);
            });
    });

    /* ======================================================================
       Scroll-lock helper — refcounted so overlapping drawers/popups don't
       wipe each other's body lock. Each open() pairs with one close().
       ====================================================================== */
    var spScrollLockCount = 0;
    function spLockScroll() {
        spScrollLockCount++;
        if (spScrollLockCount === 1) document.body.style.overflow = 'hidden';
    }
    function spUnlockScroll() {
        if (spScrollLockCount <= 0) return;
        spScrollLockCount--;
        if (spScrollLockCount === 0) document.body.style.overflow = '';
    }

    /* ======================================================================
       9. WELCOME POPUP — sessionStorage-gated
       Open after data-delay ms unless already seen. Liquid is gated by
       settings.enable_welcome_popup (no #welcomePopup → no-op). On Shopify
       customer-form roundtrip, .welcome-popup-success → open + mark seen so
       user sees confirmation once; .welcome-popup-error → open without
       marking seen so the user can retry. Prototype: script.js §11.
       ====================================================================== */
    var welcomePopup = document.getElementById('welcomePopup');
    var welcomePopupClose = document.getElementById('welcomePopupClose');
    var welcomePopupOverlay = document.getElementById('welcomePopupOverlay');
    var welcomePopupDismiss = document.getElementById('welcomePopupDismiss');
    var welcomePopupOpenedFromError = false;

    function openWelcomePopup() {
        if (!welcomePopup) return;
        if (welcomePopup.classList.contains('active')) return;
        welcomePopup.classList.add('active');
        welcomePopup.setAttribute('aria-hidden', 'false');
        spLockScroll();
    }

    function closeWelcomePopup() {
        if (!welcomePopup) return;
        if (!welcomePopup.classList.contains('active')) return;
        welcomePopup.classList.remove('active');
        welcomePopup.setAttribute('aria-hidden', 'true');
        spUnlockScroll();
        if (!welcomePopupOpenedFromError) {
            try { sessionStorage.setItem('welcomePopupSeen', '1'); } catch (e) { }
        }
    }

    if (welcomePopup) {
        var welcomePopupSuccess = welcomePopup.querySelector('.welcome-popup-success');
        var welcomePopupError = welcomePopup.querySelector('.welcome-popup-error');
        var welcomePopupSeen = false;
        try { welcomePopupSeen = sessionStorage.getItem('welcomePopupSeen') === '1'; } catch (e) { }

        if (welcomePopupSuccess) {
            try { sessionStorage.setItem('welcomePopupSeen', '1'); } catch (e) { }
            openWelcomePopup();
        } else if (welcomePopupError) {
            welcomePopupOpenedFromError = true;
            openWelcomePopup();
        } else if (!welcomePopupSeen) {
            var welcomePopupDelay = parseInt(welcomePopup.getAttribute('data-delay'), 10);
            if (isNaN(welcomePopupDelay) || welcomePopupDelay < 0) welcomePopupDelay = 2000;
            setTimeout(openWelcomePopup, welcomePopupDelay);
        }

        if (welcomePopupClose) welcomePopupClose.addEventListener('click', closeWelcomePopup);
        if (welcomePopupOverlay) welcomePopupOverlay.addEventListener('click', closeWelcomePopup);
        if (welcomePopupDismiss) welcomePopupDismiss.addEventListener('click', closeWelcomePopup);

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && welcomePopup.classList.contains('active')) {
                closeWelcomePopup();
            }
        });
    }

    /* ======================================================================
       10. COUNTRY SELECTOR — handled by Dawn's <localization-form> custom
       element (assets/localization-form.js). Posts country_code to the
       Shopify localization form, which switches the active market.
       ====================================================================== */

    /* ======================================================================
       11. SEARCH DRAWER — open / close / clear
       Ports prototype script.js search block (lines 583-668). The header's
       desktop `.header-search input` redirects focus/click to the drawer so
       the inline input is just a visual affordance — typing happens in the
       drawer. Search tags inside the drawer click-to-fill the input.
       Clear button hides when input is empty. ESC + overlay close.
       Drawer markup lives in snippets/search-drawer.liquid (rendered from
       theme.liquid). Predictive Search API hookup is a Round 2 task.
       ====================================================================== */
    var searchDrawer = document.getElementById('searchDrawer');
    var searchOverlay = document.getElementById('searchOverlay');
    var searchDrawerTrigger = document.getElementById('searchDrawerTrigger');
    var searchDrawerClose = document.getElementById('searchDrawerClose');
    var searchDrawerInput = document.getElementById('searchDrawerInput');
    var searchDrawerClear = document.getElementById('searchDrawerClear');
    var headerSearchInput = document.querySelector('.header-search input[type="search"]');
    var searchTags = document.querySelectorAll('.search-tag');

    function openSearch() {
        if (!searchDrawer) return;
        searchDrawer.classList.add('active');
        if (searchOverlay) searchOverlay.classList.add('active');
        searchDrawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('search-open');
        setTimeout(function () {
            if (searchDrawerInput) searchDrawerInput.focus();
        }, 200);
    }

    function closeSearch() {
        if (!searchDrawer) return;
        searchDrawer.classList.remove('active');
        if (searchOverlay) searchOverlay.classList.remove('active');
        searchDrawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('search-open');
    }

    if (searchDrawerTrigger) {
        searchDrawerTrigger.addEventListener('click', function (e) {
            e.preventDefault();
            openSearch();
        });
    }

    if (headerSearchInput && searchDrawer) {
        headerSearchInput.addEventListener('focus', function (e) {
            e.preventDefault();
            headerSearchInput.blur();
            openSearch();
        });
        headerSearchInput.addEventListener('click', function (e) {
            e.preventDefault();
            openSearch();
        });
    }

    if (searchDrawerClose) searchDrawerClose.addEventListener('click', closeSearch);
    if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

    if (searchDrawerInput) {
        searchDrawerInput.addEventListener('input', function () {
            if (searchDrawerClear) {
                searchDrawerClear.hidden = searchDrawerInput.value.length === 0;
            }
        });
    }

    if (searchDrawerClear) {
        searchDrawerClear.addEventListener('click', function () {
            if (searchDrawerInput) {
                searchDrawerInput.value = '';
                searchDrawerInput.focus();
            }
            searchDrawerClear.hidden = true;
        });
    }

    searchTags.forEach(function (tag) {
        tag.addEventListener('click', function () {
            if (searchDrawerInput) {
                searchDrawerInput.value = tag.textContent.trim();
                searchDrawerInput.focus();
                if (searchDrawerClear) searchDrawerClear.hidden = false;
            }
        });
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchDrawer && searchDrawer.classList.contains('active')) {
            closeSearch();
        }
    });

    /* ======================================================================
       12. CART DRAWER TRIGGER — header bag icon opens Dawn <cart-drawer>.
       Dawn's cart-drawer.js binds its own Escape, overlay click, and close
       button handlers in the web component constructor. We only need to
       wire SP Tools' header cart icon (#cartTrigger) to call drawer.open().
       Graceful fallback: if no <cart-drawer> is rendered, the anchor's
       href="{{ routes.cart_url }}" still navigates to the cart page.
       ====================================================================== */
    var cartTrigger = document.getElementById('cartTrigger');
    var cartDrawer = document.querySelector('cart-drawer');
    // On the cart page itself, opening the drawer is redundant/confusing —
    // let the icon behave as a plain link to /cart instead.
    var isCartPage = document.body.classList.contains('template-cart');

    if (cartTrigger && cartDrawer && typeof cartDrawer.open === 'function' && !isCartPage) {
        cartTrigger.addEventListener('click', function (e) {
            e.preventDefault();
            cartDrawer.open(cartTrigger);
        });
    }

    /* ======================================================================
       13. CONTACT FORM — wires the prototype's two-input First Name + Last
       Name into Shopify's single `contact[name]` field; double-submit guard;
       element-exists guard means this is a no-op on non-contact templates.
       Source: contact.html:180–222, sections/contact-form.liquid (SP rewrite).
       ====================================================================== */
    var contactForm = document.getElementById('contactForm');
    if (contactForm) {
        contactForm.addEventListener('submit', function () {
            var first = document.getElementById('ContactForm-firstName');
            var last = document.getElementById('ContactForm-lastName');
            var name = document.getElementById('ContactForm-name');
            if (first && last && name) {
                name.value = (first.value.trim() + ' ' + last.value.trim()).trim();
            }
            var submitBtn = document.getElementById('ContactForm-submit');
            if (submitBtn) {
                submitBtn.setAttribute('disabled', 'disabled');
                submitBtn.setAttribute('aria-busy', 'true');
            }
        });

        /* Re-enable the submit button when the page is restored from the
           browser's back/forward cache — otherwise the button stays disabled
           after Back navigation. */
        window.addEventListener('pageshow', function (event) {
            if (event.persisted) {
                var submitBtn = document.getElementById('ContactForm-submit');
                if (submitBtn) {
                    submitBtn.removeAttribute('disabled');
                    submitBtn.removeAttribute('aria-busy');
                }
            }
        });
    }

    /* ======================================================================
       14. NEXTECH FORM — wires firstName + lastName into Shopify's single
       `contact[name]` field, clamps the graduation date's `min` to today,
       and guards against double-submit. No-op on non-NexTech templates.
       Source: nextech.html:163–265, sections/nextech-application.liquid.
       ====================================================================== */
    var nextechForm = document.getElementById('nextechForm');
    if (nextechForm) {
        var nextechGrad = document.getElementById('NextechForm-graduation');
        if (nextechGrad && !nextechGrad.min) {
            nextechGrad.min = new Date().toISOString().slice(0, 10);
        }

        nextechForm.addEventListener('submit', function () {
            var first = document.getElementById('NextechForm-firstName');
            var last = document.getElementById('NextechForm-lastName');
            var name = document.getElementById('NextechForm-name');
            if (first && last && name) {
                name.value = (first.value.trim() + ' ' + last.value.trim()).trim();
            }
            var submitBtn = document.getElementById('NextechForm-submit');
            if (submitBtn) {
                submitBtn.setAttribute('disabled', 'disabled');
                submitBtn.setAttribute('aria-busy', 'true');
            }
        });

        window.addEventListener('pageshow', function (event) {
            if (event.persisted) {
                var submitBtn = document.getElementById('NextechForm-submit');
                if (submitBtn) {
                    submitBtn.removeAttribute('disabled');
                    submitBtn.removeAttribute('aria-busy');
                }
            }
        });
    }

    /* ======================================================================
       CART ERROR → RESYNC CART UI + surface error message
       Dawn's product-form.js returns early on /cart/add.js errors without
       re-rendering cart sections. When Shopify partially fulfills (e.g. user
       asks for 5, only 3 remain → 3 added, error reports the rest), the cart
       drawer, header badge, and cart page stay stale until refresh. Refetch
       every cart-related section currently in the DOM and patch the relevant
       nodes. Do NOT call cart-drawer.renderContents — that auto-opens the
       drawer, which would be surprising on error.
       Also exposed for the quick-add catch path, which bypasses <product-form>
       and never publishes PUB_SUB_EVENTS.cartError.
       ====================================================================== */
    function spRefreshCartSections() {
        // Each target: {sectionId, destSelector, sourceSelector}
        //   sectionId       — what we ask Shopify for (and the key in state.sections)
        //   destSelector    — element in the current DOM whose innerHTML we replace
        //   sourceSelector  — element inside the returned section HTML whose innerHTML we use
        // Mirrors Dawn cart-drawer.js / cart.js getSectionsToRender + renderContents.
        var targets = [];
        var seenSections = {};
        function addTarget(sectionId, destSelector, sourceSelector) {
            if (!sectionId || seenSections[sectionId]) return;
            if (!document.querySelector(destSelector)) return;
            seenSections[sectionId] = true;
            targets.push({
                sectionId: sectionId,
                destSelector: destSelector,
                sourceSelector: sourceSelector || destSelector
            });
        }

        addTarget('cart-drawer', '#CartDrawer', '#CartDrawer');
        addTarget('cart-icon-bubble', '#cart-icon-bubble', '.shopify-section');

        var mainCartItems = document.getElementById('main-cart-items');
        if (mainCartItems) {
            addTarget(mainCartItems.dataset.id || 'main-cart-items', '#main-cart-items .js-contents', '.js-contents');
        }
        var mainCartFooter = document.getElementById('main-cart-footer');
        if (mainCartFooter) {
            addTarget(mainCartFooter.dataset.id || 'main-cart-footer', '#main-cart-footer .js-contents', '.js-contents');
        }

        if (!targets.length) return;

        var sectionsParam = targets.map(function (t) { return t.sectionId; }).join(',');
        var cartUpdateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update.js';

        fetch(cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
                updates: {},
                sections: sectionsParam,
                sections_url: window.location.pathname
            })
        })
            .then(function (response) { return response.json(); })
            .then(function (state) {
                if (!state || !state.sections) return;

                var parser = new DOMParser();
                targets.forEach(function (target) {
                    var html = state.sections[target.sectionId];
                    if (!html) return;
                    var doc = parser.parseFromString(html, 'text/html');
                    var sourceEl = doc.querySelector(target.sourceSelector);
                    var destEl = document.querySelector(target.destSelector);
                    if (!sourceEl || !destEl) return;
                    destEl.innerHTML = sourceEl.innerHTML;
                });

                var isEmpty = state.item_count === 0;
                var drawerEl = document.querySelector('cart-drawer');
                if (drawerEl) {
                    drawerEl.classList.toggle('is-empty', isEmpty);
                    var drawerInner = drawerEl.querySelector('.drawer__inner');
                    if (drawerInner) drawerInner.classList.toggle('is-empty', isEmpty);
                }
                var cartItemsEl = document.querySelector('cart-items');
                if (cartItemsEl) cartItemsEl.classList.toggle('is-empty', isEmpty);
                if (mainCartFooter) mainCartFooter.classList.toggle('is-empty', isEmpty);
            })
            .catch(function () { /* non-critical; original error message still shows */ });
    }

    /* Render Shopify's add-to-cart error on the product card that triggered it.
       Used by the collection-page quick-add catch since there's no <product-form>
       error wrapper to display the description in. */
    function spShowCardError(trigger, message) {
        if (!trigger || !message) return;
        var card = trigger.closest('.product-card');
        var host = (card && card.querySelector('.product-media')) || (trigger && trigger.parentElement);
        if (!host) return;
        var errorEl = host.querySelector('.product-card-error');
        if (!errorEl) {
            errorEl = document.createElement('div');
            errorEl.className = 'product-card-error';
            errorEl.setAttribute('role', 'alert');
            host.appendChild(errorEl);
        }
        errorEl.textContent = message;
        // Force reflow so the transition runs even if the element was just created.
        void errorEl.offsetWidth;
        errorEl.classList.add('is-visible');
        if (errorEl._dismissTimer) clearTimeout(errorEl._dismissTimer);
        errorEl._dismissTimer = setTimeout(function () {
            errorEl.classList.remove('is-visible');
        }, 5000);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
        subscribe(PUB_SUB_EVENTS.cartError, function (event) {
            if (!event || event.source !== 'product-form') return;
            spRefreshCartSections();
        });
    }

});
